/*=========================================================================================
  File Name: store.js
  Description: Vuex store

  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/

import Vue from 'vue'
import Vuex from 'vuex'

import state from './state'
import getters from './getters'
import appMutations from './mutations'
import actions from './actions'

Vue.use(Vuex)

// shared
import moduleAuth from './auth/moduleAuth.js'

// Self-Improvee
import app from './Self-Improvee/App'
import dream from './Self-Improvee/Dream'
import goal from './Self-Improvee/Goal'
import insight from './Self-Improvee/Insight'
import story from './Self-Improvee/Story'
// import subgoal from './Self-Improvee/Subgoal'
import user from './Self-Improvee/User'
import tips from './Self-Improvee/Tips'
import routines from './Self-Improvee/Routine'
import tasks from './Self-Improvee/Tasks'
import reviews from './Self-Improvee/Reviews'
import lessons from './Self-Improvee/Lesson'
import notifications from './Self-Improvee/Notifications'
import settings from './Self-Improvee/Settings'

import { vuexfireMutations } from 'vuexfire'

const mutations = {...appMutations,  ...vuexfireMutations}

export default (ctx) => new Vuex.Store({
  getters,
  mutations,
  state,
  actions,

  modules: {
    // Shared
    auth: moduleAuth(ctx),

    // Self-Improvee
    app,
    dream,
    goal,
    insight,
    story,
    user,
    tips,
    routines,
    tasks,
    reviews,
    lessons,
    notifications,
    settings
  },
  strict: process.env.NODE_ENV !== 'production'
})
